import { useIntl } from "react-intl";
import Badge from "components/v2/Badge/Badge";
import { ReactComponent as RateCardIcon } from "assets/images/iconsV2/rate-card.svg";
import { ReactComponent as SpotRateIcon } from "assets/images/iconsV2/spot-rate.svg";

interface QuotationTypeBadgeProps {
  quotation: any;
}

export default function QuotationTypeBadge({ quotation }: QuotationTypeBadgeProps) {
  const intl = useIntl();
  const { general } = quotation;

  const isRateCardQuote = general?.is_rate_card_quote;

  if (isRateCardQuote) {
    return (
      <Badge
        label={intl.formatMessage({
          id: "settings.rate-cards.rateCard",
          defaultMessage: "Rate Card",
        })}
        color="purple"
        type="category-badge"
        variant="icon-leading"
        icon={<RateCardIcon className="icon" height={16} width={16} />}
      />
    );
  }

  return (
    <Badge
      label={intl.formatMessage({
        id: "general.spotRate",
        defaultMessage: "Spot Rate",
      })}
      color="pink"
      type="category-badge"
      variant="icon-leading"
      icon={<SpotRateIcon className="icon" height={16} width={16} />}
    />
  );
}
